import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
import DataTableTdCheckbox from '@/components/datatable/DataTableTdCheckbox.vue';
import DataTableThCheckbox from '@/components/datatable/DataTableThCheckbox.vue';
import DataTableTruncate from '@/components/datatable/DataTableTruncate.vue';
import type { Transaction } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Transaction>[] = [
    {
        accessorKey: 'select',
        header: ({ table }) => h(DataTableThCheckbox, { table }),
        cell: ({ row }) => h(DataTableTdCheckbox, { row }),
        enableHiding: false,
        size: 24,
        enableColumnFilter: false,
    },
    {
        accessorKey: 'date',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.date',
            }),
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'originalText',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.originalText',
            }),
    },
    {
        accessorKey: 'detail.message',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.message',
            }),
        cell: ({ row }) => {
            return h(DataTableTruncate, {
                value: row.original.text,
                size: 'sm',
            });
        },
    },
    {
        accessorKey: 'originalCurrency',
        accessorFn: (row) => row.originalCurrency ?? row.currency,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.currency',
            }),
        cell: ({ row }) => row.original.originalCurrency ?? row.original.currency,
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'originalAmount',
        accessorFn: (row) => row.originalAmount ?? row.amount,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.amount',
            }),
        cell: ({ row }) => {
            return h(DataTableCurrency, {
                value: row.original.originalAmount ?? row.original.amount,
                withColor: true,
            });
        },
        meta: {
            filterType: 'currency',
        },
    },
    {
        accessorKey: 'exchangeRate',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.transaction_rate',
            }),
    },
    {
        accessorKey: 'transactionAmount',
        accessorFn: (row) => row.transactionAmount?.value,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.amount_dkk',
            }),
        cell: ({ row }) => {
            return h(DataTableCurrency, {
                value: row.original.transactionAmount?.value,
                withColor: true,
            });
        },
        meta: {
            filterType: 'currency',
        },
    },
    {
        accessorKey: 'maskedPan',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.card',
            }),
    },
    {
        accessorKey: 'cardHolder',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.by',
            }),
    },
    {
        accessorKey: 'type',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.transaction_type',
            }),
    },
    {
        accessorKey: 'reference',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.reference',
            }),
    },
    {
        accessorKey: 'balance',
        accessorFn: (row) => row.balance?.value,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.transactions_table.balance',
            }),
        cell: ({ row }) => {
            return h(DataTableCurrency, {
                value: row.original.balance?.value,
                withColor: false,
            });
        },
        meta: {
            filterType: 'currency',
        },
    },
];
